import { api } from '../api';

// Unwrap the {success, data} envelope to the inner DTO.
const unwrap = (r) => r?.data ?? r;

export default {
  list:        (params)    => api.get('/v1/vehicles', { params }).then(r => r.data),
  /** Dealership-wide KPI counts — { total, inStock, reserved, aged }. */
  stats:       ()          => api.get('/v1/vehicles/stats').then(r => unwrap(r.data)),
  /** Distinct makes for the filter dropdown. */
  makes:       ()          => api.get('/v1/vehicles/makes').then(r => unwrap(r.data)),
  get:         (id)        => api.get(`/v1/vehicles/${id}`).then(r => r.data),
  create:      (body)      => api.post('/v1/vehicles', body).then(r => unwrap(r.data)),
  update:      (id, body)  => api.put(`/v1/vehicles/${id}`, body).then(r => unwrap(r.data)),
  setStatus:   (id, status) => api.patch(`/v1/vehicles/${id}/status`, { stockStatus: status })
                                  .then(r => unwrap(r.data)),

  /** Upload one or more photo files to the app's default storage; returns URLs. */
  uploadImages: (files) => {
    const fd = new FormData();
    Array.from(files).forEach((f) => fd.append('files', f));
    return api.post('/v1/vehicles/images', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then((r) => unwrap(r.data));
  },

  /** Bulk import / update inventory from a CSV/XLSX file (multipart). */
  importFile: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post('/v1/vehicles/import', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(r => unwrap(r.data));
  },

  // Inventory extras (module wave)
  priceHistory:    (id)         => api.get(`/v1/vehicles/${id}/price-history`).then(r => unwrap(r.data)),
  interestedLeads: (id)         => api.get(`/v1/vehicles/${id}/interested-leads`).then(r => unwrap(r.data)),
  addInterest:     (id, leadId) => api.post(`/v1/vehicles/${id}/interested-leads`, { leadId }).then(r => unwrap(r.data)),

  /** Create a DRAFT campaign targeting customers interested in this aged unit's model. */
  agedCampaign:    (id)         => api.post(`/v1/vehicles/${id}/aged-campaign`).then(r => unwrap(r.data)),

  // Inventory settings — dealer-configurable aged-stock threshold (days).
  getSettings:     ()           => api.get('/v1/reports/inventory/settings').then(r => unwrap(r.data)),
  setAgedThreshold:(days)       => api.put('/v1/reports/inventory/settings', { agedStockThresholdDays: days }).then(r => unwrap(r.data)),
};
